import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Footer";
import NavbarCustom from "../NavbarCustom";
import FooterMain from "../../Components/Footer/Footer";
import Bar from "../BottomBar/Bar";
const Layout = () => {
  return (
    <div>
      <NavbarCustom />
      <Bar />
      <Outlet />
      <Footer />
      <FooterMain />
    </div>
  );
};

export default Layout;
